<template>
    <div
        v-if="badges.length"
        class="product-promotion-badges product-promotion-badges--overlay"
    >
        <span
            v-for="(badge, index) in badges"
            :key="index"
            class="product-promotion-badge"
            :style="{
                '--promotion-badge-color': badge.color,
                '--promotion-badge-text-color': badge.text_color || promotionBadgeTextColor(badge.color),
            }"
        >
            <span
                v-if="isFlagBadge(badge)"
                :class="['fi', `fi-${badgeFlagCode(badge)}`, 'product-promotion-badge__flag']"
                aria-hidden="true"
            ></span>
            <i
                v-else-if="bootstrapIconClass(badge)"
                :class="bootstrapIconClass(badge)"
                aria-hidden="true"
            ></i>
            <span>{{ badge.label }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'ProductPromotionBadges',
    props: {
        badges: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        promotionBadgeTextColor(hex) {
            const normalized = String(hex || '').trim();

            if (!/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(normalized)) {
                return '#111111';
            }

            let value = normalized.slice(1);

            if (value.length === 3) {
                value = value.split('').map((part) => part + part).join('');
            }

            const toLinear = (channel) => (
                channel <= 0.03928
                    ? channel / 12.92
                    : ((channel + 0.055) / 1.055) ** 2.4
            );

            const red = toLinear(parseInt(value.slice(0, 2), 16) / 255);
            const green = toLinear(parseInt(value.slice(2, 4), 16) / 255);
            const blue = toLinear(parseInt(value.slice(4, 6), 16) / 255);
            const luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;

            return luminance > 0.45 ? '#111111' : '#ffffff';
        },
        badgeFlagCode(badge) {
            if (badge?.flag_code) {
                return badge.flag_code;
            }

            const match = String(badge?.icon_value || '').match(/^flag-([a-z]{2})$/i);

            return match ? match[1].toLowerCase() : '';
        },
        isFlagBadge(badge) {
            return badge?.icon_type === 'flag' || this.badgeFlagCode(badge) !== '';
        },
        bootstrapIconClass(badge) {
            const value = badge?.icon_class || badge?.icon_value;

            if (!value || this.isFlagBadge(badge)) {
                return null;
            }

            if (value.startsWith('bi ')) {
                return value;
            }

            if (value.startsWith('bi-')) {
                return `bi ${value}`;
            }

            return `bi bi-${value}`;
        },
    },
};
</script>
